import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from './Button';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleNav = () => history.goBack();

  return (
    <div className="min-h-[calc(100vh-200px)] flex flex-col items-center justify-center p-4 bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark transition-colors duration-300">
      <div className="text-center">
        <p className="text-lg text-secondary-900">{t('404')}</p>
        <h1 className="mt-4 text-3xl text-gray-900 sm:text-5xl">
          {t('Page not found')}
        </h1>
        {/* <p className="mt-6 text-base leading-7 text-gray-600">
          {t('Try ')}
        </p> */}
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button variant="primary" size="small" onClick={handleNav}>
            {t('Back')}
          </Button>
          <Link to="/help/support">
            <Button variant="secondary" size="small">
              {t('Support')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
